import { useRef } from "react";

let componentId = 1;
const generateNextId = () => componentId++;

// TODO: Replace with useId once we upgrade React 18 or higher
export function useComponentId() {
  const componentId = useRef<string>();
  if (componentId.current === undefined) {
    componentId.current = `:stotles:${generateNextId()}:`;
  }
  return componentId.current;
}
